import clsx from "clsx";
import React, { CSSProperties, FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  editable?: boolean;
  underColor?: "green" | "red";
  onClick?: () => void;
  ["data-test-id"]?: string;
};

export const GridHeader: FC<Props> = ({
  children,
  className,
  style,
  editable,
  underColor,
  onClick,
  "data-test-id": dataTestId,
}) => {
  return (
    <div
      className={clsx(className, editable ? "editable" : "")}
      onClick={editable ? onClick : undefined}
      style={style}
      data-test-id={dataTestId}
    >
      {children}
      {underColor && <span className={`label-${underColor}`} />}
    </div>
  );
};
